import { Injectable } from '@angular/core';
import { DatePicker, Dropdown } from '@com-delta-omnichannel/mach-core-js';
import {
  StaysComponents,
  StaysWidget
} from '../models/stays-widget.interfaces';

@Injectable({
  providedIn: 'root'
})
export class InitializationService {
  initializeComponents(content: StaysWidget): StaysComponents {
    return {
      datePickerInstance: new DatePicker(content.dropDownDateOption),
      dropDownTravelerOptions: new Dropdown(content.dropDownTravelerOption),
      dropDownRoomOptions: new Dropdown(content.dropDownRoomOption)
    };
  }

  getRequiredElements(content: StaysWidget): boolean {
    return !!(
      document.getElementById(content.dropDownTravelerOption.id) &&
      document.getElementById(content.dropDownRoomOption.id) &&
      document.getElementById(content.dropDownDateOption.id)
    );
  }
}
